/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrganizationIPWhitelist } from './OrganizationIPWhitelist';
import {
    OrganizationIPWhitelistFromJSON,
    OrganizationIPWhitelistFromJSONTyped,
    OrganizationIPWhitelistToJSON,
    OrganizationIPWhitelistToJSONTyped,
} from './OrganizationIPWhitelist';

/**
 * 
 * @export
 * @interface FindAllOrganizationIPWhitelistResponseData
 */
export interface FindAllOrganizationIPWhitelistResponseData {
    /**
     * 
     */
    organization_id?: string;
    /**
     * 
     */
    whitelist?: Array<OrganizationIPWhitelist>;
    /**
     * 
     */
    count?: number;
}

/**
 * Check if a given object implements the FindAllOrganizationIPWhitelistResponseData interface.
 */
export function instanceOfFindAllOrganizationIPWhitelistResponseData(value: object): value is FindAllOrganizationIPWhitelistResponseData {
    return true;
}

export function FindAllOrganizationIPWhitelistResponseDataFromJSON(json: any): FindAllOrganizationIPWhitelistResponseData {
    return FindAllOrganizationIPWhitelistResponseDataFromJSONTyped(json, false);
}

export function FindAllOrganizationIPWhitelistResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllOrganizationIPWhitelistResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'whitelist': json['whitelist'] == null ? undefined : ((json['whitelist'] as Array<any>).map(OrganizationIPWhitelistFromJSON)),
        'count': json['count'] == null ? undefined : json['count'],
    };
}

export function FindAllOrganizationIPWhitelistResponseDataToJSON(json: any): FindAllOrganizationIPWhitelistResponseData {
    return FindAllOrganizationIPWhitelistResponseDataToJSONTyped(json, false);
}

export function FindAllOrganizationIPWhitelistResponseDataToJSONTyped(value?: FindAllOrganizationIPWhitelistResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'organization_id': value['organization_id'],
        'whitelist': value['whitelist'] == null ? undefined : ((value['whitelist'] as Array<any>).map(OrganizationIPWhitelistToJSON)),
        'count': value['count'],
    };
}

